import { createAction } from '@reduxjs/toolkit';
import { IUser } from '../../../interfaces/user';
import { AppThunk } from '../../store';
import { getAuth } from '../../../services/AuthHttpService';
import { DEV_PORTAL_API_URL } from '../../../app-config';

export const getUserErrorAction = createAction<string>('GET_USER_ERROR');
export const resetUserAction = createAction('RESET_USER');

export const getUserAction = createAction<IUser | undefined>('GET_USER');

export function getUser(): AppThunk {
  return async (dispatch) => {
    try {
      const user = await getAuth<IUser>(`${DEV_PORTAL_API_URL}/api/user`);

      if (user.parsedBody) {
        return dispatch(getUserAction(user.parsedBody));
      }
    } catch (e) {
      return dispatch(getUserErrorAction('Error fetching User'));
    }
  };
}
